var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgActivity = function SvgActivity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26 26"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.227 14.88H4.801a.8.8 0 0 1-.646-1.272L13.481.83c.456-.625 1.446-.303 1.446.472v9.215a.8.8 0 0 0 .8.8h5.426a.8.8 0 0 1 .646 1.272l-9.326 12.778c-.456.625-1.446.302-1.446-.472V15.68a.8.8 0 0 0-.8-.8Z"
  })));
};
export default SvgActivity;